class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("change", this.onVariantChange);
    
    // Ensure handleize function exists
    if (!window.handleize) {
      window.handleize = function(str) {
        if (!str) return '';
        return str
          .toLowerCase()
          .replace(/[^a-z0-9]+/g, '-')
          .replace(/^-+|-+$/g, '');
      };
    }
    
    // Ensure accessibilityStrings exists
    if (!window.accessibilityStrings) {
      window.accessibilityStrings = {
        imageAvailable: 'Image {index} is now active in the gallery view',
        shareSuccess: 'Link copied to clipboard',
        pauseSlideshow: 'Pause slideshow',
        playSlideshow: 'Play slideshow'
      };
    }
    
    // Ensure simply object exists
    if (!window.simply) {
      window.simply = {
        money_format: "{{amount}}"
      };
    } else if (!window.simply.money_format) {
      // If simply exists but money_format is missing, add it
      window.simply.money_format = "{{amount}}";
    }
    
    // Ensure variantStrings exists
    if (!window.variantStrings) {
      window.variantStrings = {
        addToCart: 'Add To Cart',
        soldOut: 'Sold out',
        unavailable: 'Unavailable',
        preorder: 'Pre-order',
        nostock: 'Out of stock',
        discountLabel: 'Save',
        unavailable_with_option: '[value] is unavailable'
      };
    }
  }

  onVariantChange() {
    this.updateOptions();
    this.updateOptionsParent();
    this.updateMasterId();
    this.updateMetafieldCardImagesFromData();
    this.updateVariantCSSColors();
    
    // 1. Immediate Visual Feedback (High Priority)
    this.toggleAddButton(true, "", false);
    this.updatePriceImmediately(); // Moved up for speed

    // 2. Yield to the browser to finish the "Click" paint
    // This reduces the Processing Duration in your INP report
    requestAnimationFrame(() => {
      setTimeout(() => {
        this.getPreOrderVariantData();
        this.updatePickupAvailability();
        this.updateContent();
        this.updateVariantStatuses();

        if (!this.currentVariant) {
          this.toggleAddButton(true, "", true);
          this.setUnavailable();
        } else {
          this.updateMedia();
          this.updateURL();
          this.updateVariantInput();
          this.renderProductInfo();
          this.updateUpsell();
        }
      }, 0);
    });
  }

  updateMetafieldCardImagesFromData() {
    const cards = this.querySelectorAll(".metafields-data-wrapper");
    if (!cards.length) return;

    const variantMetafields = this.getVariantMetafieldData();
    if (!variantMetafields || !variantMetafields.length) return;

    const selectedByPosition = {};
    const fieldsets = Array.from(this.querySelectorAll("fieldset[data-option-position]"));
    fieldsets.forEach((fieldset) => {
      const position = parseInt(fieldset.dataset.optionPosition, 10);
      if (!position) return;
      const checkedInput = fieldset.querySelector('input[type="radio"]:checked');
      if (checkedInput) selectedByPosition[position] = checkedInput.value;
    });

    cards.forEach((card) => {
      const img = card.querySelector(".variant-image img");
      if (!img) return;

      const fieldset = card.closest("fieldset[data-option-position]");
      if (!fieldset) return;

      const cardOptionPosition = parseInt(fieldset.dataset.optionPosition, 10);
      const cardValue = card.dataset.filter || card.dataset.pack;
      if (!cardOptionPosition || !cardValue) return;

      const matchedVariant = variantMetafields.find((variant) => {
        if (`${variant[`option${cardOptionPosition}`] || ""}` !== `${cardValue}`) return false;

        for (let i = 1; i <= 3; i += 1) {
          if (i === cardOptionPosition) continue;
          const selectedValue = selectedByPosition[i];
          if (!selectedValue) continue;
          if (`${variant[`option${i}`] || ""}` !== `${selectedValue}`) return false;
        }
        return true;
      });

      if (!matchedVariant || !matchedVariant.variant_image_160) return;

      img.src = matchedVariant.variant_image_160;
      img.srcset = `${matchedVariant.variant_image_120} 120w, ${matchedVariant.variant_image_160} 160w, ${matchedVariant.variant_image_200} 200w`;
    });
  }

  updateVariantCSSColors() {
    const section = document.querySelector('.main-product[data-section-id]');
    if (!section) return;

    const metafields = this.getVariantMetafieldData();
    const matched = metafields.find((v) => v.id === this.currentVariant?.id);

    const resolve = (variantValue, dataAttr) =>
      (matched && matched[variantValue]) || section.dataset[dataAttr] || null;

    const primary = resolve('ww_primary_color', 'productPrimaryColor');
    const secondary = resolve('ww_secondary_color', 'productSecondaryColor');
    const base = resolve('ww_base_color', 'productBaseColor');

    if (primary) {
      section.style.setProperty('--color-ww-pdp-primary', primary);
      document.documentElement.style.setProperty('--color-ww-pdp-primary', primary);
    }
    if (secondary) {
      section.style.setProperty('--color-ww-pdp-secondary', secondary);
      document.documentElement.style.setProperty('--color-ww-pdp-secondary', secondary);
    }
    if (base) {
      section.style.setProperty('--color-ww-pdp-base', base);
      document.documentElement.style.setProperty('--color-ww-pdp-base', base);
    }
  }

  updateUpsell() {
    let upsellWrapper = document.querySelector('.product-upsells');
    if (!upsellWrapper) {
      return;
    }
    let allUpsell = upsellWrapper.querySelectorAll('.product-upsells-wrapper');
    if (allUpsell.length === 0) {
      return;
    }
    allUpsell.forEach(element => {
      element.classList.add('d-none');
    });
    let currentUpsell = upsellWrapper.querySelector(`.product-upsells-wrapper[data-id="${this.currentVariant.id}"]`);
    if (currentUpsell) {
      currentUpsell.classList.remove('d-none');
    }
  }

  updateOptions() {
    this.options = Array.from(
      this.querySelectorAll("select"),
      (select) => select.value
    );
  }

  updateOptionsParent() {
    Array.from(this.querySelectorAll(".product-form__input--dropdown")).map(
      (select, index) => {
        select.children[0].children[1].innerHTML = this.options[index];
      }
    );
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;

    const mediaGallery = document.getElementById(
      `MediaGallery-${this.dataset.section}`
    );

    if (!mediaGallery) return;

    const optionHandles = (this.currentVariant.options || []).map(opt =>
      window.handleize ? window.handleize(opt) : opt.toLowerCase().replace(/[^a-z0-9]+/g, '-')
    );

    requestAnimationFrame(() => {
      if (typeof mediaGallery.switchByVariantTitle === 'function') {
        for (const handle of optionHandles) {
          if (mediaGallery.switchByVariantTitle(handle)) return;
        }
      }

      if (this.currentVariant.featured_media && typeof mediaGallery.setActiveMedia === 'function') {
        mediaGallery.setActiveMedia(
          `${this.dataset.section}-${this.currentVariant.featured_media.id}`,
          true
        );
      }
    });
  }

  connectedCallback() {
    requestAnimationFrame(() => {
      this.updateOptions();
      this.updateMasterId();
      if (this.currentVariant) this.updateMedia();
    });
  }

  updateContent() {
    let variant = this.currentVariant;

    let variandID = this.currentVariant?.id ?? null;

    // Back In Stock Notification
    let notifyMeAvailableWrapper = document.querySelector(
      ".notify__me--available"
    );
    if (variandID != null && !variant.available) {
      let soldOurtProductURL = document.querySelector(".soldout__product_url");
      soldOurtProductURL.value = `${this.dataset.origin}${this.dataset.url}?variant=${this.currentVariant.id}`;
      if (notifyMeAvailableWrapper) {
        notifyMeAvailableWrapper.classList.remove("no-js-inline");
      }
    } else {
      if (notifyMeAvailableWrapper) {
        notifyMeAvailableWrapper.classList.add("no-js-inline");
      }
    }
  }

  /* Shopify Money Format */
  formatMoney = function (t, e = (window.simply && window.simply.money_format) || "Rs. {{amount}}") {
    function o(t, e) {
      return void 0 === t ? e : t;
    }
    function i(t, e, i, r) {
      if (
        ((e = o(e, 2)), (i = o(i, ",")), (r = o(r, ".")), isNaN(t) || null == t)
      )
        return 0;
      t = (t / 100).toFixed(e);
      var n = t.split(".");
      return (
        n[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + i) +
        (n[1] ? r + n[1] : "")
      );
    }
    "string" == typeof t && (t = t.replace(".", ""));
    var r = "",
      n = /\{\{\s*(\w+)\s*\}\}/,
      a = e || this.money_format || "Rs. {{amount}}";
    var match = a.match(n);
    var formatType = match ? match[1] : "amount";
    switch (formatType) {
      case "amount":
        r = i(t, 0);
        break;
      case "amount_no_decimals":
        r = i(t, 0);
        break;
      case "amount_with_comma_separator":
        r = i(t, 2, ".", ",");
        break;
      case "amount_with_space_separator":
        r = i(t, 2, " ", ",");
        break;
      case "amount_with_period_and_space_separator":
        r = i(t, 2, " ", ".");
        break;
      case "amount_no_decimals_with_comma_separator":
        r = i(t, 0, ".", ",");
        break;
      case "amount_no_decimals_with_space_separator":
        r = i(t, 0, " ");
        break;
      case "amount_with_apostrophe_separator":
        r = i(t, 2, "'", ".");
        break;
      default:
        r = i(t, 0);
    }
    // Always return the full formatted string with currency prefix
    if (match) {
      return a.replace(n, r);
    } else {
      // If no match, ensure we still include "Rs." prefix
      return a.includes("Rs.") ? a.replace(/\{\{amount\}\}/g, r).replace(/\{\{\s*amount\s*\}\}/g, r) : ("Rs. " + r);
    }
  };


  updateURL() {
    if(this?.currentVariant && this?.querySelector("fieldset.variant-package-wrapper")) {
      let mixedFruitPrices = JSON.parse(this.querySelector("[data-variant]").textContent)
      .filter(item => item.option2 === this.currentVariant.option2)
      .reduce((acc, item) => {
        acc[item.option1] ={
          price: item.price,
          compare_at_price: item.compare_at_price,
        } 
        return acc;
      }, {});
      let bodyTag = document.querySelector('body')
      if(bodyTag){
        bodyTag.classList.forEach(className => {
          if (className.startsWith('product-variant-')) {
            bodyTag.classList.remove(className);
          }
        });
        bodyTag.classList.add(`product-variant-${window.handleize(this?.currentVariant?.option2)}`)
      }

      try{
        const discountAmount = this?.currentVariant.price - 10000;
        const formattedDiscount = `Rs. ${(discountAmount / 100).toFixed(2).replace(/\.00$/, '')}`;
        $("#wuwEffectiveDiscountInBanner").text(formattedDiscount);
      }catch(e){
        console.log("",e)
      }
      if(mixedFruitPrices) {
        const priceValues = Object.values(mixedFruitPrices);
        const formatPrice = (cents) => `Rs. ${(cents / 100).toFixed(2).replace(/\.00$/, '')}`;
        const updatePackPrices = (packItems) => {
          packItems.forEach((item, index) => {
            const data = priceValues[index];
            if (!data) return;
            const { price, compare_at_price } = data;
            const formattedPrice = formatPrice(price);
            const regularEl = item.querySelector(".product-variant-price, .variant-price--regular");
            const saleEl = item.querySelector(".variant-price--sale");
            const enablePriceSaving = !!item.querySelector(".enable-price-saving");
            if (regularEl) regularEl.textContent = formattedPrice;
            if (saleEl) {
              if (enablePriceSaving) {
                saleEl.textContent = `Now: ${formattedPrice.replace(/^Rs\.\s*/, '₹')}`;
              } else {
                saleEl.textContent = formattedPrice.replace(/^Rs\.\s*/, '').replace(/,/g, '');
              }
            }
            if (compare_at_price && item.querySelector(".variant-price--regular")) {
              item.querySelector(".variant-price--regular").textContent = formatPrice(compare_at_price);
            }
          });
        };
        if (this.closest('.collection-popup')) {
          updatePackPrices(this.closest('.collection-popup').querySelectorAll(".pdp-swatch-wrapper.package-wrapper .js-filter"));
        } else {
          updatePackPrices(document.querySelectorAll(".pdp-swatch-wrapper.package-wrapper .js-filter:not(.mobile-extra-item)"));
          updatePackPrices(document.querySelectorAll(".pdp-swatch-wrapper.package-wrapper .js-filter.mobile-extra-item"));
          if (document.querySelector(".pdp-swatch-wrapper.package-wrapper .js-filter.mobile-extra-item")) {
            if (this.querySelector('.js-filter.mobile-extra-item')) {
              this.querySelector('.js-filter.mobile-extra-item').closest('fieldset').querySelectorAll('input').forEach((ele) => {
                if (ele.checked) {
                  let id = ele.id;
                  id = id.slice(0, id.length - 2);
                  if (document.querySelector(`#${id}`)) document.querySelector(`#${id}`).checked = true;
                }
              })
            } else {
              this.querySelector('.js-filter').closest('fieldset').querySelectorAll('input').forEach((ele) => {
                if (ele.checked) {
                  let id = ele.id;
                  if (document.querySelector(`#${id}-1`)) document.querySelector(`#${id}-1`).checked = true;
                }
              })
            }
          }
        }
      }

    }
    if (!this.currentVariant || this.dataset.updateUrl === "false") return;
    if (!this.closest('.collection-popup')) {
      window.history.replaceState(
        {},
        "",
        `${this.dataset.url}?variant=${this.currentVariant.id}`
      );
    }
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      if (input) {
        input.value = this.currentVariant.id;
        input.dispatchEvent(new Event("change", { bubbles: true }));
      }
    });
    document.dispatchEvent(new CustomEvent("variant-change", {
      bubbles: true,
      detail: { variant: this.currentVariant, sectionId: this.dataset.section }
    }));
    
    if(window.innerWidth < 767) {
      let that = this;
      let checkboxes = document.querySelectorAll("variant-radios .product-form__input input");
      if(checkboxes) {
        checkboxes.forEach(function(checkbox) {
          if (checkbox.checked) {
            const checkedValue = that.currentVariant.title;
            console.log("checkedValue",checkedValue);
            checkboxes.forEach(function(otherCheckbox) {
              if (otherCheckbox.value === checkedValue && otherCheckbox !== checkbox) {
                otherCheckbox.checked = true;
              }
            });
          }
        });
      }
    }
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(":checked").value === variant.option1
    );
    const inputWrappers = [...this.querySelectorAll(".product-form__input")];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [
        ...option.querySelectorAll('input[type="radio"], option'),
      ];
      const previousOptionSelected =
        inputWrappers[index - 1].querySelector(":checked").value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter(
          (variant) =>
            variant.available &&
            variant[`option${index}`] === previousOptionSelected
        )
        .map((variantOption) => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute("value"))) {
        input.innerText = input.getAttribute("value");
      } else {
        input.innerText = window.variantStrings.unavailable_with_option.replace(
          "[value]",
          input.getAttribute("value")
        );
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector("pickup-availability");
    if (!pickUpAvailability) return;

    // Check if the custom element is defined and the method exists
    if (this.currentVariant && this.currentVariant.available) {
      if (typeof pickUpAvailability.fetchAvailability === 'function') {
        pickUpAvailability.fetchAvailability(this.currentVariant.id);
      } else {
        // Fallback: wait for custom element to be defined
        customElements.whenDefined('pickup-availability').then(() => {
          if (pickUpAvailability.fetchAvailability) {
            pickUpAvailability.fetchAvailability(this.currentVariant.id);
          }
        }).catch(() => {
          console.warn('pickup-availability custom element not available');
        });
      }
    } else {
      pickUpAvailability.removeAttribute("available");
      pickUpAvailability.innerHTML = "";
    }
  }

  updatePriceImmediately() {
    if (!this.currentVariant) return;
    
    const priceContainer = document.getElementById(`price-${this.dataset.section}`);
    if (!priceContainer) return;

    const variant = this.currentVariant;
    const price = variant.price;
    const compareAtPrice = variant.compare_at_price;
    const available = variant.available;
    const isOnSale = compareAtPrice && compareAtPrice > price;

    // Format prices directly - ensure complete formatted string (Rs. + number) is ready before DOM update
    // Convert price from cents to rupees and format with commas
    const formatPriceValue = (priceInCents) => {
      const priceValue = Math.round(priceInCents / 100);
      return priceValue.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    };
    
    // Build complete formatted price strings (currency + number together)
    const formattedPrice = "Rs. " + formatPriceValue(price);
    const formattedCompareAtPrice = compareAtPrice ? "Rs. " + formatPriceValue(compareAtPrice) : null;

    // Update price container classes
    priceContainer.classList.remove("no-js-inline");
    const priceElement = priceContainer.querySelector(".price");
    if (priceElement) {
      priceElement.classList.toggle("price--on-sale", isOnSale);
      priceElement.classList.toggle("price--sold-out", !available);
    }

    // Update regular price - set complete formatted string at once (synchronously)
    const regularPriceElement = priceContainer.querySelector(".price__regular .price-item--regular");
    if (regularPriceElement && formattedPrice) {
      regularPriceElement.textContent = formattedPrice;
    }

    // Update sale price elements - set complete formatted strings at once (synchronously)
    if (isOnSale) {
      const comparePriceElement = priceContainer.querySelector(".price__sale .price__compare s.price-item--regular");
      const salePriceElement = priceContainer.querySelector(".price__sale .price-item--sale");
      
      if (comparePriceElement && formattedCompareAtPrice) {
        comparePriceElement.textContent = formattedCompareAtPrice;
      }
      if (salePriceElement && formattedPrice) {
        salePriceElement.textContent = formattedPrice;
      }
    }

    // Show/hide regular vs sale price divs based on sale status
    const regularDiv = priceContainer.querySelector(".price__regular");
    const saleDiv = priceContainer.querySelector(".price__sale");
    if (regularDiv && saleDiv) {
      if (isOnSale) {
        regularDiv.style.display = "none";
        saleDiv.style.display = "";
      } else {
        regularDiv.style.display = "";
        saleDiv.style.display = "none";
      }
    }
  }

  renderProductInfo() {
    fetch(
      `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`
    )
      .then((response) => response.text())
      .then((responseText) => {
        let id = `price-${this.dataset.section}`,
          stockInventory = `inventory__stock--${this.dataset.section}`,
          barcodeId = `barcode__${this.dataset.section}`,
          skuId = `sku__${this.dataset.section}`;

        const html = new DOMParser().parseFromString(responseText, "text/html");

        let destination = document.getElementById(id),
          stockInventoryDestination = document.getElementById(stockInventory),
          barcodeDestination = document.getElementById(barcodeId),
          skuDestination = document.getElementById(skuId);

        let source = html.getElementById(id),
          stockInventorySource = html.getElementById(stockInventory),
          barcodeSource = html.getElementById(barcodeId),
          skuSource = html.getElementById(skuId);

        // Update price elements directly from fetched HTML to preserve structure
        // but only update the price content, not the entire container
        if (source && destination) {
          // Find price elements in both source and destination
          const sourcePriceElement = source.querySelector(".price");
          const destPriceElement = destination.querySelector(".price");
          
          if (sourcePriceElement && destPriceElement) {
            // Only update the price element content, not the entire container
            destPriceElement.innerHTML = sourcePriceElement.innerHTML;
          } else {
            // Fallback: update entire container if structure is different
            destination.innerHTML = source.innerHTML;
          }
        }
        
        if (stockInventorySource && stockInventoryDestination)
          stockInventoryDestination.innerHTML = stockInventorySource.innerHTML;
        if (barcodeSource && barcodeDestination)
          barcodeDestination.innerHTML = barcodeSource.innerHTML;
        if (skuSource && skuDestination)
          skuDestination.innerHTML = skuSource.innerHTML;

        const price = document.getElementById(`price-${this.dataset.section}`);
        if (price) price.classList.remove("no-js-inline");
        this.toggleAddButton(
          !this.currentVariant.available,
          window.variantStrings.soldOut
        );
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const cartIcon = `<svg width="22" height="19" viewBox="0 0 22 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M21.3679 6.22188C21.2916 6.13269 21.1969 6.06109 21.0903 6.012C20.9837 5.96291 20.8678 5.93749 20.7504 5.9375H15.8754V2.6875C15.8754 2.04103 15.6186 1.42105 15.1615 0.963927C14.7044 0.506807 14.0844 0.25 13.4379 0.25H8.56291C7.91645 0.25 7.29646 0.506807 6.83934 0.963927C6.38222 1.42105 6.12541 2.04103 6.12541 2.6875V5.9375H1.25041C1.13264 5.93617 1.01598 5.96045 0.908523 6.00868C0.801067 6.05691 0.705381 6.12792 0.628094 6.2168C0.550808 6.30568 0.493769 6.4103 0.46093 6.52342C0.428091 6.63653 0.420237 6.75543 0.437912 6.87188L1.96541 16.7438C2.02417 17.1312 2.221 17.4844 2.51961 17.7383C2.81823 17.9921 3.19852 18.1294 3.59041 18.125H18.4267C18.8186 18.1294 19.1988 17.9921 19.4975 17.7383C19.7961 17.4844 19.9929 17.1312 20.0517 16.7438L21.5629 6.87188C21.5792 6.75588 21.5702 6.63773 21.5365 6.52554C21.5029 6.41335 21.4454 6.30976 21.3679 6.22188V6.22188ZM7.75041 2.6875C7.75041 2.47201 7.83602 2.26535 7.98839 2.11298C8.14076 1.9606 8.34742 1.875 8.56291 1.875H13.4379C13.6534 1.875 13.8601 1.9606 14.0124 2.11298C14.1648 2.26535 14.2504 2.47201 14.2504 2.6875V5.9375H7.75041V2.6875ZM18.4267 16.5H3.57416L2.20104 7.5625H19.7998L18.4267 16.5Z" fill="currentColor"></path>
                    </svg>`;
    const productForm = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');

    if (!addButton) return;

    if (disable) {
      // addButton.setAttribute("disabled", true);
      if (text) addButton.textContent = text;
    } else {
      // addButton.removeAttribute("disabled");
      addButton.innerHTML = `${cartIcon} ${window.variantStrings.addToCart}`;
    }

    // Preorder Button
    if (window.enable_preorder_button) {
      let productVarArray = this.PreorderVariantData;
      let variant = this.currentVariant;
      let VarInventoryManagement =
        this.currentVariant?.inventory_management ?? null;
      let var_num = "";
      if (VarInventoryManagement != null) {
        for (let variant_id in productVarArray) {
          if (variant.id == variant_id) {
            var_num = productVarArray[variant_id].qty;
            var inventoryQuantity = parseInt(var_num);
            var inventoryPolicy = productVarArray[variant_id].inventory_policy;
          }
          if (inventoryQuantity <= 0 && inventoryPolicy === "continue") {
            addButton.removeAttribute("disabled");
            addButton.innerHTML = `${cartIcon} ${window.variantStrings.preorder}`;
          } else if (inventoryQuantity <= 0 && inventoryPolicy !== "continue") {
            addButton.setAttribute("disabled", true);
            addButton.textContent = window.variantStrings.soldOut;
          } else {
            addButton.removeAttribute("disabled");
            addButton.innerHTML = `${cartIcon} ${window.variantStrings.addToCart}`;
          }
        }
      }
    }
    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    const addButton = button.querySelector('[name="add"]');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButton.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add("no-js-inline");
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector("[data-variant]").textContent);
    return this.variantData;
  }
  getPreOrderVariantData() {
    this.PreorderVariantData =
      this.PreorderVariantData ||
      JSON.parse(this.querySelector("[data-preorder]").textContent);
  }

  getVariantMetafieldData() {
    const metafieldsNode = this.querySelector("[data-variant-metafields]");
    if (!metafieldsNode) return [];
    this.variantMetafieldData =
      this.variantMetafieldData || JSON.parse(metafieldsNode.textContent);
    return this.variantMetafieldData;
  }
}

customElements.define("variant-selects", VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
    this.fieldsets = Array.from(this.querySelectorAll("fieldset"));
    this.onColorSwatches();
  }

  onColorSwatches() {
    const variantList = this.getVariantData() || [];
    const swatchButtonList = this.querySelectorAll(
      `fieldset.variant--swatch-${this.dataset.colorSwatch} > label`
    );
    const result = Object.values(
      variantList.reduce((total, item) => {
        let k = `${item[this.dataset.colorSwatch]}`;
        if (!total[k]) {
          total[k] = { ...item, count: 1 };
        } else {
          total[k].count += 1;
        }
        return total;
      }, {})
    );

    if (swatchButtonList.length > 0) {
      swatchButtonList.forEach((button) => {
        result.forEach((data) => {
          if (data[this.dataset.colorSwatch] === button.dataset.value) {
            if (
              this.dataset.colorSwatchStyle === "image" &&
              data.featured_image !== null
            ) {
              button.setAttribute(
                "style",
                `--swatch-background-image: url(${
                  data.featured_image.src
                }); --swatch-background-color: ${
                  data[this.dataset.colorSwatch]
                };`
              );
            } else {
              button.setAttribute(
                "style",
                `--swatch-background-color: ${data[this.dataset.colorSwatch]};`
              );
            }
          }
        });
      });
    }
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute("value"))) {
        input.classList.remove("disabled");
      } else {
        input.classList.add("disabled");
      }
    });
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll("fieldset"));
    this.options = fieldsets.map((fieldset, index) => {
      const radios = Array.from(fieldset.querySelectorAll('input[type="radio"]'));
      const checked = radios.find((radio) => radio.checked);
      const value = checked ? checked.value : undefined;
      // Preserve previous option if none checked (e.g. metafields layout or timing)
      if (value !== undefined) return value;
      if (this.options && this.options[index] !== undefined) return this.options[index];
      return '';
    });
  }

  updateOptionsParent() {
    this.fieldsets.forEach((fieldset, index) => {
      const legend = fieldset.children[0];
      const span = legend && legend.children[1];
      if (span && this.options && this.options[index] !== undefined) {
        span.innerHTML = this.options[index];
      }
    });
  }
  
}
customElements.define("variant-radios", VariantRadios);
